const features = [
  {
    title: '台北娜娜：年度话题女王全记录',
    desc: '从最新视频到过往合集，台北娜娜的每一个高光时刻都在这里。深度梳理她的娱乐圈影响力演变，包含独家专访片段和未公开花絮。',
    tag: '热门人物',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20magazine%20cover%20style%20image%20with%20warm%20coral%20red%20and%20golden%20accents%2C%20elegant%20entertainment%20spotlight%20concept%2C%20abstract%20stage%20light%20and%20star%20elements%20on%20soft%20cream%20background%2C%20glamorous%20yet%20sophisticated%20aesthetic%2C%20high%20quality&width=900&height=560&seq=carousel-01&orientation=landscape',
  },
  {
    title: '莫里秀合集：全网最全时间线整理',
    desc: '莫里秀从出道至今的完整事件时间线，每一个重要节点都不遗漏。配合独家分析文章，让你全面了解这位热门人物的来龙去脉。',
    tag: '独家整理',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%20image%20of%20comprehensive%20archive%20and%20collection%20concept%2C%20warm%20amber%20and%20terracotta%20tones%2C%20abstract%20bookshelf%20and%20timeline%20elements%20on%20clean%20neutral%20background%2C%20organized%20and%20thorough%20aesthetic&width=900&height=560&seq=carousel-02&orientation=landscape',
  },
  {
    title: '玩偶姐姐揭秘：神秘面纱之下的真相',
    desc: '关于玩偶姐姐，网上流传着各种版本的说法。我们收集整理了最可靠的线索和信息，用数据和事实说话，带你接近真相。',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20editorial%20concept%20of%20mystery%20unveiling%20theme%2C%20warm%20coral%20and%20gold%20gradients%2C%20abstract%20veil%20lifting%20and%20revelation%20elements%20on%20soft%20cream%20background%2C%20intriguing%20and%20elegant%20mood%2C%20professional%20investigation%20style&width=900&height=560&seq=carousel-03&orientation=landscape',
  },
  {
    title: '2025吃瓜半年鉴：那些年我们追过的瓜',
    desc: '上半年娱乐圈大事件全景回顾。从年初的惊天大瓜到最近的连环爆料，每一件都影响着吃瓜圈的格局。',
    tag: '年度特辑',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20style%20image%20of%20retrospective%20and%20milestone%20review%20concept%2C%20golden%20and%20terracotta%20color%20palette%2C%20abstract%20calendar%20pages%20and%20highlight%20markers%20on%20soft%20neutral%20background%2C%20reflective%20and%20comprehensive%20mood&width=900&height=560&seq=carousel-04&orientation=landscape',
  },
  {
    title: '吃瓜文化现象：为什么我们热爱围观',
    desc: '从社会心理学角度分析吃瓜文化盛行的深层原因。探讨当代互联网语境下，吃瓜群众如何影响舆论走向和公众认知。',
    tag: '文化观察',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20social%20observation%20and%20cultural%20analysis%20concept%2C%20warm%20amber%20and%20coral%20accents%2C%20abstract%20crowd%20and%20perspective%20elements%20on%20clean%20light%20background%2C%20thoughtful%20and%20insightful%20aesthetic&width=900&height=560&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选深度专题内容，全方位解读热门话题
          </p>
        </div>

        <div className="flex flex-col gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/50"
            >
              <div className="flex flex-col md:flex-row">
                <div className={`relative overflow-hidden md:w-[420px] flex-shrink-0 ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-48 md:h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 px-2.5 py-1 text-[11px] font-medium rounded-full bg-accent-500 text-white">
                    {item.tag}
                  </span>
                </div>
                <div className={`p-5 md:p-7 flex flex-col justify-center flex-1 ${i % 2 === 1 ? 'md:order-1' : ''}`}>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <div className="mt-4">
                    <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 cursor-pointer hover:text-primary-600 transition-colors">
                      阅读全文
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}